"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetStreams = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var common_streams_utils_1 = require("@moralisweb3/common-streams-utils");
var StreamNetwork_1 = require("../utils/StreamNetwork");
var IncorrectNetworkError_1 = require("../utils/IncorrectNetworkError");
var makeGetAptosStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.PaginatedOperationResolver(common_streams_utils_1.getStreamsAptosOperation, baseUrl, core).fetch(options);
};
var makeGetEvmStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.PaginatedOperationResolver(common_streams_utils_1.getStreamsEvmOperation, baseUrl, core).fetch(options);
};
var makeGetStreams = function (core, baseUrl) {
    return (function (getStreamsOptions) {
        switch (getStreamsOptions.networkType) {
            case StreamNetwork_1.StreamNetwork.APTOS:
                return makeGetAptosStream(core, baseUrl, getStreamsOptions);
            case StreamNetwork_1.StreamNetwork.EVM:
                return makeGetEvmStream(core, baseUrl, getStreamsOptions);
            default:
                if (getStreamsOptions.networkType === undefined) {
                    return makeGetEvmStream(core, baseUrl, getStreamsOptions);
                }
                throw new IncorrectNetworkError_1.IncorrectNetworkError(getStreamsOptions.networkType);
        }
    });
};
exports.makeGetStreams = makeGetStreams;
//# sourceMappingURL=getAll.js.map